export default function ($routeProvider, $locationProvider, $rootScopeProvider, $injector) {
    'ngInject';
    $locationProvider.hashPrefix('');

    $routeProvider
	    .when('/', {
	      template: require('./partials/homepage.html'),
	      controller: 'HomePageController'
	    })
	    .when('/ancestry/:entryID', {
    	      template: require('./partials/percentages.html'),
            controller: 'PercentagesController'
	    })
	    .when('/ancestrytree/:entryID', {
            template: require('./partials/ancestrytree.html'),
            controller: 'AncestryTreeController'
        })
	    .when('/breedtests/:entryID',{
            template: require('./partials/breedtests.html'),
            controller: 'BreedTestsController'
        })
        .when('/mixedbreedgroups/:entryID', {
            template: require('./partials/mixedbreedgroups.html'),
            controller: 'MixedComponentController'
        })
	    .when('/breed/:entryId', {
            template: require('./partials/breed.html'),
            controller: 'BreedController'
        })
         .when('/breedsanalyzed/:entryID', {
            template: require('./partials/breedsanalyzed.html'),
            controller: 'BreedsAnalyzedController'
        })
        .when('/certificate/:entryID', {
            template: require('./partials/certificate.html'),
            controller: 'BreedsCertificateController'
        })
        .when('/health/:entryID', {
            template: require('./partials/health.html'),
            controller: 'HealthController'
        })
        .when('/atrisk/:entryID', {
            template: require('./partials/atrisk.html'),
            controller: 'AtRiskController'
        })
        .when('/carrier/:entryID', {
            template: require('./partials/carrier.html'),
            controller: 'CarrierController'
        })
        .when('/allclear/:entryID', {
            template: require('./partials/allclear.html'),
            controller: 'AllClearController'
        })
        .when('/nocall/:entryID', {
            template: require('./partials/nocall.html'),
            controller: 'NoCallController'
        })
        .when('/multidrugsensitivity/:entryID', {
            template: require('./partials/multidrugsensitivity.html'),
            controller: 'MultidrugSensitivityController'
        })
        .when('/traits/:entryID', {
            template: require('./partials/traits.html'),
            controller: 'TraitsController'
        })
		.when('/eic/:entryID', {
            template: require('./partials/eic.html'),
            controller: 'EICController'
        })
        .when('/adultweight/:entryID', {
            template: require('./partials/adultweight.html'),
            controller: 'AdultWeightController'
        })
         .when('/notes/:entryID', {
            template: require('./partials/notes.html'),
            controller: 'NotesController'
        })
         .when('/exceptionletter', {
            template: require('./partials/exceptionletter.html'),
            controller: 'ExceptionLetterController'
        })
         .when('/pbddletter', {
            template: require('./partials/pbddletter.html'),
            controller: 'PBDDLetterController'
        })
         .when('/learnmore/:entryID', {
            template: require('./partials/learnmore.html'),
            controller: 'LearnMoreController'
        })
         .when('/thescience/:entryID', {
            template: require('./partials/thescience.html'),
            controller: 'TheScienceController'
        })
         .when('/technology/:entryID', {
            template: require('./partials/technology.html'),
            controller: 'TechnologyController'
        })
        .when('/inheritance/:entryID', {
            template: require('./partials/inheritance.html'),
            controller: 'InheritanceController'
        })
         .when('/faqs/:entryID', {
            template: require('./partials/faqs.html'),
            controller: 'FaqsController'
        })
         .when('/learnmoreTraits/:entryID', {
            template: require('./partials/learnmoreTraits.html'),
            controller: 'LearnMoreTraitsController'
        })
        .when('/glossary/:entryID', {
            template: require('./partials/glossary.html'),
            controller: 'GlossaryController'
        });
}



// WEBPACK FOOTER //
// ./client/apps/dnareport/app.routeConfig.js